import { Layout } from '@components/Layout';
import { PageHeader } from '@components/PageHeader';
import Header from '@components/_OldDesign/header';
import { ReactElement } from 'react';
import { NextPageWithLayout } from './_app';
import { strapi } from 'models/conent';
import Image from 'next/image';
import Link from 'next/link';

const PrivacyPolicyPage: NextPageWithLayout = () => {
  return (
    <>
      <Header content={{
          title: 'Privacy Policy - นโยบายความเป็นส่วนตัวของ CODIUM',
          content: 'เรียนรู้เกี่ยวกับนโยบายความเป็นส่วนตัวของ CODIUM เราให้ความสำคัญกับการปกป้องข้อมูลส่วนบุคคลของคุณและการใช้งานข้อมูลอย่างปลอดภัย',
          image: null,
        }}/>
      <PageHeader
        topic="ประกาศความเป็นส่วนตัว"
        detail="บริษัท โคเดียม จำกัด (“เรา”) ให้ความสำคัญกับการคุ้มครองความเป็นส่วนตัวของท่าน เราจึงให้ความรับรองว่า เราจะเก็บรวบรวม ใช้ และ/หรือเปิดเผยข้อมูลส่วนบุคคลเพื่อให้เป็นไปตามประกาศความเป็นส่วนตัวของเราตามทีได้ ระบุไว้เท่านั้น โปรดศึกษาประกาศความเป็นส่วนตัวได้ที่นี่"
        backgroundImage="/images/privacy-policy/privacy-policy-page-header.png"
      />

      <div
        className="relative w-screen h-fit py-16"
        style={{ minHeight: '50vh' }}
      >
        <section className="Container">
          <div className="flex flex-col space-y-10 lg:ml-12 lg:mb-32">
            {contents.map((content) => (
              <Link key={content.id} href={content.fileUrl} passHref>
                <a
                  target="_blank"
                  className="flex flex-row justify-start items-center p-5 space-x-5 rounded-md hover:cursor-pointer hover:bg-slate-100 lg:max-w-[55%]"
                >
                  <div className="">
                    <Image
                      src="/images/privacy-policy/privacy-policy-file-icon.png"
                      alt={content.fileUrl}
                      width={59}
                      height={59}
                      layout="fixed"
                    />
                  </div>
                  <div className="flex flex-col space-y-3">
                    <h2 className="text-p2Regular font-medium text-lightBlue underline">
                      {content.topic}
                    </h2>
                    <p className="text-p4Regular text-gray-600">
                      {content.detail}
                    </p>
                  </div>
                </a>
              </Link>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

PrivacyPolicyPage.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export default PrivacyPolicyPage;

const contents = [
  {
    id: 1,
    topic: 'ลูกค้า และบุคคลทั่วไป',
    detail:
      'ประกาศความเป็นส่วนตัวสำหรับลูกค้า และบุคคลทั่วไปของบริษัทฯ หรือมีความเกี่ยวข้องกับบริษัทฯ ของ บริษัท โคเดียม จำกัด',
    fileUrl:
      strapi +
      '/uploads/Privacy_notice_Customer_CODIUM_25_07_2022_pdf_1_74aad20caa.pdf',
  },
  {
    id: 2,
    topic: 'พนักงาน กรรมการบริษัทฯ ',
    detail:
      'ประกาศความเป็นส่วนตัวของบริษัท โคเดียม จำกัด สำหรับพนักงาน กรรมการบริษัทฯ ผู้บริหารระดับสูง ผู้ถือหุ้นของบริษัทฯ สมาชิกในครอบครัวของพนักงาน หรือบุคคลใดที่พนักงานได้ให้ข้อมูลไว้',
    fileUrl:
      strapi +
      '/uploads/Privacy_notice_Employee_CODIUM_25_07_2022_docx_8235ec1d90.pdf',
  },
  {
    id: 3,
    topic: 'ผู้สมัครงาน ',
    detail:
      'ประกาศความเป็นส่วนตัวของบริษัท โคเดียม จำกัด สำหรับผู้สมัครงาน สมาชิกในครอบครัวของผู้สมัครงาน หรือบุคคลใดที่ผู้สมัครงานได้ให้ข้อมูลไว้',
    fileUrl:
      strapi +
      '/uploads/Privacy_notice_Candidate_CODIUM_25_07_2022_docx_2_a4b3695eca.pdf',
  },
  {
    id: 4,
    topic: 'ผู้มีความสัมพันธ์ทางธุรกิจ',
    detail:
      'ประกาศความเป็นส่วนตัวสำหรับผู้ที่มีความสัมพันธ์ทางธุรกิจของ บริษัท โคเดียม จำกัด',
    fileUrl:
      strapi +
      '/uploads/Privacy_notice_business_Partnership_CODIUM_09_08_2022_64c5d6fe30.pdf',
  },
];
